<template>
    <div class="hr-normal-data">
        <div v-for="(item,index) in list" :key="index" class="hr-normal-bg">
            <div class="hr-normal-data-img" :style="{ backgroundColor: item.color }"><img :src="item.icon"/></div>
            <div class="hr-content-section">                
                <div class="hr-normal-data-title">{{item.value}}</div>
                <div class="hr-normal-data-num">
                    {{item.name}}(bpm)
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HeartRateNomalData",
    props: [
        'maxHr',
        'minHr',
        'avgHr',
    ],

    computed: {
        list () {
            return [
                {value: this.avgHr>0?this.avgHr:'-', name: this.$t("message")['HeartRate.avghr'], icon: require("../../assets/avg_hr.png"), key: 1, color: '#F8FBFF'},
                {value: this.maxHr>0?this.maxHr:'-', name: this.$t("message")['HeartRate.maxhr'], icon: require("../../assets/max_hr.png"), key: 2, color: '#FFEFEF'},
                {value: this.minHr>0?this.minHr:'-', name: this.$t("message")['HeartRate.minhr'], icon: require("../../assets/min_hr.png"), key: 3, color: '#FFF8F7'}
            ]
        }
    }
}
</script>

<style scoped>
.hr-normal-data {
    width: 100%;
    display: flex;
    justify-content: space-around;
    padding-left: 10px;
}

.hr-normal-bg {
    height: 60px;
    width: 196px;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(1, 24, 54, 0.1);
    display: flex;
}

.hr-content-section {
    width: 136px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
}

.hr-normal-data-title {
    font-size: 22px;
    color: #2C2C3B;
    text-align: left;
    font-family: PingFang-SC-Semibold;
    text-align: center;
    width: 60px;
}

.hr-normal-data-num {
    font-size: 13px;
    color: #606165;
    width: 136px;
    text-align: left;
    font-family: PingFang SC-Medium;
    text-align: center;
    justify-content: space-around;
}

.hr-normal-data-img {
    width: 60px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>